import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { SnackbarComponentData } from 'app/store/models/snackbar.model';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss'],
})
export class SnackbarComponent implements OnInit, AfterViewInit {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public config: SnackbarComponentData,
    public snackBarRef: MatSnackBarRef<SnackbarComponent>,
  ) {
  }

  ngOnInit() {
    console.log(this.config);
  }

  ngAfterViewInit() {
  }

  isArray(value: any) {
    return Array.isArray(value);
  }

  checkType(value, type) {
    if (typeof value === type) {
      return true;
    }

    return false;
  }

  onButtonClicked() {
    if (this.config.button && this.config.button.onClick) {
      this.config.button.onClick(this);
      return;
    }
    this.snackBarRef.dismiss();
  }
}
